'use client'

import { BottomMenuComponent } from '../../../shared/ui-kit/actual/BottomMenuComponent'
import { AppProvider } from '../../providers/AppProvider/AppProvider'

export function ItemBottomMenuClient() {
  return (
    <AppProvider>
      <BottomMenuComponent />
    </AppProvider>
  )
}
